<h2 mat-dialog-title>
	<span i18n="@@MoveCharger">Move Charger</span> {{ data.chargerId }}
</h2>

<mat-dialog-content style="padding-top: 12px;">
	@if (!loaded()) {
	<mat-spinner diameter="32" />
	} @else {
	<mat-form-field appearance="outline" class="full-width">
		<mat-label i18n="@@TargetGroup">Target Group</mat-label>
		<mat-select [(value)]="selectedGroupId">
			@for (group of groups(); track group.groupId) {
			<mat-option [value]="group.groupId">{{ group.path }}</mat-option>
			}
		</mat-select>
	</mat-form-field>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="cancel()" i18n="@@Cancel">Cancel</button>
	<button matButton="elevated" color="primary" (click)="move()" [disabled]="!selectedGroupId"
		i18n="@@Move">Move</button>
</mat-dialog-actions>